import styled from 'styled-components'
import { theme } from 'styles/theme'

export const ChordContainer = styled.div`
  position: relative;
  width: 100%;
  font-family: 'Roboto Condensed', sans-serif;
  overflow: hidden;
  margin-top: var(--spacing-lg);
  /*padding: 16px;
  border-radius: 16px;
  background-color: #feedf3;*/
`
export const ChordHeader = styled.div`
  margin: 0px;
  padding: 0px;
  border: none;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  gap: 16.2px;
`
export const ChordTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  //color: rgb(56, 56, 56);
  color: ${theme.colors.text};
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`

export const ChordDescription = styled.p`
  font-size: 16px;
  //color: rgb(56, 56, 56);
  color: ${theme.colors.text};
  font-weight: 400;
  margin: 0;
`

export const ChordLegend = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  margin-top: 10px;
  color: rgb(19, 47, 70);
  line-height: 1.4;
  font-size: 14px;
  @media (max-width: 482px) {
    grid-template-columns: 1fr;
  }
`
export const LegendCategories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`
export const LegendSwatch = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: max(1lh, 14px) auto;
  min-height: 14px;
  column-gap: 3px;
`
export const LegendSquereContainer = styled.div`
  display: grid;
  align-content: center;
`
export const LegendSquere = styled.div<{ $color: string }>`
  display: grid;
  align-content: center;
  align-self: center;
  width: 14px;
  height: 14px;
  background: ${(props) => props.$color};
`
export const LegendLabel = styled.div`
  grid-row: span 2;
  align-self: center;
  line-height: 1.4;
  font-weight: 400;
  font-size: 14px;
`
export const Chord = styled.div`
  margin: auto;
  max-width: 420px;
  svg {
    cursor: default;
  }
  @media (max-width: 432px) {
    svg {
      transform: scale(1.2);
    }
  }
  @media (max-width: 380px) {
    margin-top: 3rem;
    margin-bottom: 3rem;
    svg {
      transform: scale(1.5);
    }
  }
`

export const ChordPopup = styled.div`
  position: absolute;
  bottom: 4rem;
  background: #fff;
  border: 1px solid #f5f5f5;
  box-shadow: 3px 3px 3px #0000001a;
  font-size: 13px;
  font-weight: 700;
  color: rgb(56, 56, 56);
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  padding: 10px;
  transition: opacity 0.2s;
`

export const ChordSource = styled.div`
  color: rgb(19, 47, 70);
  font-size: 11px;
  font-weight: 400;
`
